<template>
  <zm-drawer ref="drawer" :title="title" :footer="false" :visible="visible" @cancel="ShutDown">
    <div slot="drawerBody">
      <zm-label title="考核基础信息" />
      <a-form :form="form">
        <a-row>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="姓名">
              <span>{{ model.userName }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="考核部门">
              <span>{{ model.deptName }}</span>
            </a-form-item>
          </a-col>
          <a-divider orientation="left"></a-divider>
        </a-row>
      </a-form>
      <zm-label title="考核记录" />
      <div class="table">
        <a-table
          :columns="table.columns"
          :rowKey="(record) => record.id"
          :dataSource="table.data"
          :pagination="pagination"
          :loading="table.loading"
          @change="handleTableChange"
          :scroll="{ x: 1220, y: 300 }"
        >
          <template slot="actions" slot-scope="text, record">
            <a href="javascript:;" @click="() => handleIgnore(record)" v-show="record.status === 1">忽略</a>
            <a-divider type="vertical" v-show="record.status === 1" />
            <a href="javascript:;" @click="() => handleEditor(record)">编辑</a>
            <a-divider type="vertical" />
            <a href="javascript:;" @click="() => handleView(record)">查看</a>
          </template>
        </a-table>
      </div>
      <!--各种弹出组件-->
      <ig-nore ref="igNore" @refreshTable="initTableData"></ig-nore>
      <edit-modal-one ref="editModalOne" @refreshTable="initTableData"></edit-modal-one>
    </div>
  </zm-drawer>
</template>
<script>
import { mapState } from 'vuex'
import { getUserEvaluateOne } from '@/api/assessment'
import IgNore from './igNore.vue'
import editModalOne from './editModalOne.vue'

export default {
  name: 'editAssessment',
  mounted() {},
  computed: {
    isEdit() {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
    drawerWidth() {
      const width = window.innerWidth - 200
      return width
    },
    ...mapState({}),
  },
  components: {
    IgNore,
    editModalOne
  },
  data() {
    return {
      title: '操作',
      width: 1000,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'assessment' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 21 },
      },
      colSpan: 12,
      table: {
        data: [],
        config: {},
        columns: [
          {
            title: '姓名',
            dataIndex: 'userName',
            width: 60,
          },
          {
            title: '截止考核日期',
            dataIndex: 'deadline',
            width: 80,
          },
          {
            title: '填写日期',
            dataIndex: 'fillInTime',
            width: 80,
          },
          {
            title: '周期类型',
            dataIndex: 'type',
            customRender: (text) => {
              // 编译后端传来的数据为数字的值
              if (text === 1) return '第一季度'
              if (text === 2) return '半年度'
              if (text === 3) return '第三季度'
              if (text === 4) return '年度'
            },
            width: 80,
          },
          {
            title: '直属领导',
            dataIndex: 'fillInUserName',
            width: 80,
          },
          {
            title: '考核评分',
            dataIndex: 'score',
            width: 80,
          },
          {
            title: '考核结果',
            dataIndex: 'scoreLevelStr',
            width: 80,
          },
          {
            title: '状态',
            dataIndex: 'status',
            customRender: (text) => {
              if (text === 0) return '已考核'
              if (text === 1) return '待考核'
              if (text === 9) return '考核忽略'
            },
            width: 80,
          },
          {
            title: '操作',
            fixed: 'right',
            width: 160,
            align: 'center',
            scopedSlots: {
              customRender: 'actions',
            },
          },
        ],
        searchCondition: {},
        loading: false,
        filteredInfo: null,
        sortedInfo: null,
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      tableList: [],
    }
  },
  methods: {
    // 设置标题
    setTitle(title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel(model) {
      this.model = Object.assign({}, model)
    },
    // 点击抽屉右上角的XX符号
    ShutDown() {
      this.visible = false
      this.$emit('refreshTable')
    },
    // 打开or关闭，修改的窗口先获取详情
    open(flag) {
      this.visible = flag
      if (flag == true) {
        this.initTableData()
      }
    },
    // 清空表单
    formClear() {
      this.form.setFieldsValue({ score: '', scoreLevel: [] })
      this.model.name = ''
      this.model.headName = ''
      this.model.deptName = ''
      this.model.type = ''
      this.model.deadline = null
      this.model.deadline = null
    },
    // 初始化表格
    initTableData() {
      getUserEvaluateOne({ userId: this.model.userId }).then((res) => {
        if (res.status === 0) {
          this.table.loading = false
          this.table.data = res.data.list
          this.pagination.total = res.data.total
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 切换页码等操作
    handleTableChange(pagination, filters, sorter) {
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.pagination.current = pagination.current
      this.searchModel = {
        ...this.searchModel,
        ...this.pagination,
      }
      this.initTableData()
    },
    // 点击操作栏的忽略按钮
    handleIgnore(model) {
      this.$refs.igNore.setTitle('忽略本次考核')
      this.$refs.igNore.setModel(model) // 先设置类型，再打开
      this.$refs.igNore.open(true)
    },
    // 点击操作栏的编辑按钮
    handleEditor(model) {
      this.$refs.editModalOne.setTitle('编辑')
      this.$refs.editModalOne.setType(this.$sysInfo.MODAL_EDITOR)
      this.$refs.editModalOne.setModel(model)
      this.$refs.editModalOne.open(true)
    },
    // 点击操作栏的查看按钮
    handleView(model) {
      this.$refs.editModalOne.setTitle('查看')
      this.$refs.editModalOne.setType(this.$sysInfo.MODAL_VIEW)
      this.$refs.editModalOne.setModel(model)
      this.$refs.editModalOne.open(true)
    },
  },
}
</script>

<style scoped lang="less">
.table {
  margin-top: 10px;
}
.ant-form-item {
  .text,
  .textArea {
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 0 10px;
  }
}
</style>

